/**
 * Util for handle boolean possible undefined environment variables
 *
 * @param {(string | undefined)} value current boolean/stringfied environment variable
 * @param {boolean} def the default value that the environment variable should have
 */
export const handleBoolEnv = (value: string | undefined, def: boolean): boolean =>
  typeof value !== undefined ? value === 'true' : def
